/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_Dtos_TwoFactor_TwoFactorVerificationResultDto } from '../models/Wealthlane_Dtos_TwoFactor_TwoFactorVerificationResultDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TwoFactorVerificationService {

    /**
     * @param input 
     * @returns Wealthlane_Dtos_TwoFactor_TwoFactorVerificationResultDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiTwoFactorVerificationCustomerVerify(
input: string,
): CancelablePromise<Wealthlane_Dtos_TwoFactor_TwoFactorVerificationResultDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/two-factor-verification/customer/{input}/verify',
            path: {
                'input': input,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param recoveryCode 
     * @returns Wealthlane_Dtos_TwoFactor_TwoFactorVerificationResultDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiTwoFactorVerificationCustomerVerifyByRecoveryCode(
recoveryCode: string,
): CancelablePromise<Wealthlane_Dtos_TwoFactor_TwoFactorVerificationResultDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/two-factor-verification/customer/{recoveryCode}/verify-by-recovery-code',
            path: {
                'recoveryCode': recoveryCode,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param input 
     * @returns Wealthlane_Dtos_TwoFactor_TwoFactorVerificationResultDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiTwoFactorVerificationPptVerify(
input: string,
): CancelablePromise<Wealthlane_Dtos_TwoFactor_TwoFactorVerificationResultDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/two-factor-verification/ppt/{input}/verify',
            path: {
                'input': input,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param recoveryCode 
     * @returns Wealthlane_Dtos_TwoFactor_TwoFactorVerificationResultDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiTwoFactorVerificationPptVerifyByRecoveryCode(
recoveryCode: string,
): CancelablePromise<Wealthlane_Dtos_TwoFactor_TwoFactorVerificationResultDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/two-factor-verification/ppt/{recoveryCode}/verify-by-recovery-code',
            path: {
                'recoveryCode': recoveryCode,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
